export default "__VITE_ASSET__fRlaO0u2__"